export default __webpack_public_path__ + "static/media/misc-closetB-1024w.65c37da4.avif";